import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDiagonalRightUpOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M18.2 17H20V4H7v1.8h9.927L4 18.727 5.273 20 18.2 7.073z" fill="currentColor" />
            </g>
        </svg>
    )
);
ArrowDiagonalRightUpOutlinedSize24Glyph.displayName = 'ArrowDiagonalRightUpOutlinedSize24Glyph';
